export default "__VITE_ASSET__WbDSKmNL__"